<template>
  <div class="editor-prepaid">
    <div class="ms-nodata ms-help" v-if="isNotAvailable">
      Для указания условий получения аванса необходимо заполнить
      все атрибуты по каждому этапу календарного плана (номер, название, сроки и
      сумма)
    </div>
    <div v-else class="editor-prepaid__container">
      <wrapper :contract="contract" name="Аванс" type="prepaid" />
      <div class="editor-prepaid__tasks" v-if="contract.prepaid">
        <div class="editor-prepaid__tasks-control">
          <i-button type="primary" @click="togglePaymentTasks">
            {{
              paymentTasksShow
                ? "Убрать поэтапное получение аванса"
                : "Добавить поэтапное получение аванса"
            }}
          </i-button>
        </div>
        <row :gutter="48">
          <i-col span="14">
            <payment-tasks-list
              v-if="paymentTasksShow"
              :contract="contract"
              @toggle-off="closeList"
            />
          </i-col>
        </row>
      </div>
    </div>
  </div>
</template>

<script>
import Wrapper from '../helpers/special-conditions/wrapper'
import PaymentTasksList from '../helpers/special-conditions/payment-tasks-list'
import { isRoadmapInvalid } from '@/utils'

export default {
  props: ['contract'],
  data () {
    return {
      paymentTasksShow: false
    }
  },
  components: {
    Wrapper,
    PaymentTasksList
  },
  computed: {
    isNotAvailable () {
      const { roadmaps } = this.contract

      if (!roadmaps) return true

      if (!roadmaps.length) return true
      if (roadmaps.filter(r => !r.is_retention).some(isRoadmapInvalid)) { return true }

      return false
    }
  },
  watch: {
    '$props.contract.prepaid' (val) {
      if (!val) this.paymentTasksShow = false
    }
  },
  methods: {
    togglePaymentTasks () {
      if (!this.paymentTasksShow) {
        const tasks = [
          { id: Date.now().valueOf(), payment_date: null, value: 0 },
          { id: Date.now().valueOf() + 1, payment_date: null, value: 0 }
        ]

        this.$set(this.contract, 'payment_tasks', tasks)
      } else {
        this.$set(this.contract, 'payment_tasks', [])
      }

      this.paymentTasksShow = !this.paymentTasksShow
    },
    closeList () {
      this.paymentTasksShow = false
    }
  },
  created () {
    this.paymentTasksShow = !!this.contract.payment_tasks.length
  }
}
</script>

<style lang="less">
.editor-prepaid {
  &__tasks {
    margin-top: 24px;

    &-control {
      margin-bottom: 4px;
    }
  }
}
</style>
